// Legacy "Filters" panel (still used by older pages elsewhere — keep
// the export so we don't break unrelated imports).
import Filters from "./Filters/Filters";

// Dashboard primitives
import KpiCard from "./KpiCard/KpiCard";
import ChartCard from "./ChartCard/ChartCard";
import SectionTitle from "./SectionTitle/SectionTitle";
import Sparkline from "./Sparkline/Sparkline";
import Stars from "./Stars/Stars";
import Delta from "./Delta/Delta";

// Dashboard widgets
import KpiRow from "./KpiRow/KpiRow";
import ResponseTimeChart from "./ResponseTimeChart/ResponseTimeChart";
import DurationByTypeChart from "./DurationByTypeChart/DurationByTypeChart";
import DeclineReasonsChart from "./DeclineReasonsChart/DeclineReasonsChart";
import RatingDistribution from "./RatingDistribution/RatingDistribution";
import RatingTrend from "./RatingTrend/RatingTrend";
import TechnicianRanking from "./TechnicianRanking/TechnicianRanking";
import RecentLowRatings from "./RecentLowRatings/RecentLowRatings";
import DashboardFilters from "./DashboardFilters/DashboardFilters";
import LiveIndicator from "./LiveIndicator/LiveIndicator";

export {
  Filters,
  // Primitives
  KpiCard,
  ChartCard,
  SectionTitle,
  Sparkline,
  Stars,
  Delta,
  // Widgets
  KpiRow,
  ResponseTimeChart,
  DurationByTypeChart,
  DeclineReasonsChart,
  RatingDistribution,
  RatingTrend,
  TechnicianRanking,
  RecentLowRatings,
  DashboardFilters,
  LiveIndicator
};
